import { render, staticRenderFns } from "./AreaEdit.vue?vue&type=template&id=ec2b09c6&scoped=true"
import script from "./AreaEdit.vue?vue&type=script&lang=js"
export * from "./AreaEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec2b09c6",
  null
  
)

export default component.exports